import { createAsyncThunk, Dispatch } from "@reduxjs/toolkit";
import { Message, Tracker } from "../../interfaces/interfaces";
import API from "../../rest/api";
import { RestS } from "../../rest/rest-service";
import {
  addMessages,
  addSingleMessageReceived,
  ChatState,
  UnreadCount,
} from "./chatSlice";
import { Channel } from "../../interfaces/interfaces";

export const UpdateAsyncChannelUnreadStatus = createAsyncThunk(
  "chatSlice/UpdateAsyncChannelUnreadStatus",
  async (
    { channelId, unreadCount }: { channelId: number; unreadCount: number },
    { getState, rejectWithValue, dispatch }
  ) => {
    try {
      // const { messagesLoadedChannels, unreadMessages } = getState()[
      //   "chatState"
      // ] as ChatState;
      const updateStatus = await RestS.updateChannelBulkMessageStatus(
        channelId
      );
      //
      // if (updateStatus) {
      //
      return {
        channelId: channelId,
        decrementCount: unreadCount,
        unreadCount: updateStatus,
      };
      // } else {
      //   return null;
      // }
    } catch (error) {
      //
      return rejectWithValue(error);
    }
  }
);

export const fetchAsyncMessages = createAsyncThunk(
  "chatSlice/getAsyncMessages",
  async (
    {
      channelId,
      message,
      userId,
    }: { channelId: number; message: Message; userId: string },
    { getState, rejectWithValue, dispatch }
  ) => {
    try {
      const { messagesLoadedChannels, unreadMessages } = getState()[
        "chatState"
      ] as ChatState;
      //
      if (
        !messagesLoadedChannels.hasOwnProperty(`${channelId}`) ||
        !unreadMessages.hasOwnProperty(`${channelId}`)
      ) {
        const messages = await RestS.getChannelMessages(channelId);

        const unreadCount = await RestS.getChannelUnreadCount(
          channelId.toString()
        );
        const unreadCountObj = unreadCount.reduce((prev, curr) => {
          prev[`${curr.channelId}`] = curr;
          return prev;
        }, {});
        // dispatch(
        //   addMessages({
        //     channelId: channelId,
        //     messages: messages,
        //     unreadCount: unreadCount,
        //   })
        // );
        return {
          channelId: channelId,
          messages: messages,
          unreadCount: unreadCountObj,
        };
      } else {
        dispatch(addSingleMessageReceived({ channelId, message, userId }));
        return null;
      }
    } catch (error) {
      //
      return rejectWithValue(error);
    }
  }
);

const getChannels = async () => {
  try {
    const data = await RestS.getChannelsByLatestActivity();
    return data;
  } catch (error) {
    throw error;
  }
};

const getTrackers = async () => {
  try {
    const data = await RestS.getTrackersInOrder();
    return data;
  } catch (error) {
    //
    throw error;
  }
};

export const fetchAsyncChannelsAndTrackers = createAsyncThunk(
  "chatSlice/getAsyncChannelsAndTrackers",
  async (userId: string, { rejectWithValue }) => {
    try {
      const data = await Promise.all([getChannels(), getTrackers()]).catch(
        (error) => {
          return rejectWithValue(error);
        }
      );
      // const data = await getChannels();
      //
      return {
        unpinnedChannels: data[0]["unpinnedChannels"],
        pinnedChannels: data[0]["pinnedChannels"],
        unreadCount: data[0]["unreadCount"],
        trackers: data[1],
      } as {
        unpinnedChannels: Channel[];
        pinnedChannels: Channel[];
        unreadCount: UnreadCount[];
        trackers: Tracker[];
      };
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);

export const updateAsyncChannelPinStatus = createAsyncThunk(
  "chatslice/togglepinstatus",
  async (
    { channelId, value }: { channelId: number; value: boolean },
    { getState, rejectWithValue }
  ) => {
    try {
      const { pinnedChannelList, sortedChannelList, channels } = getState()[
        "chatState"
      ] as ChatState;
      const data = await RestS.togglePinChannel(channelId, value);
      if (value) {
        const newPinnedChannelList = [`${channelId}`, ...pinnedChannelList];
        const channelIndex = [...sortedChannelList].findIndex(
          (item) => item.toString() == channelId.toString()
        );
        if (channelIndex == -1) {
          return {
            pinnedChannelList,
            sortedChannelList,
            channel: channels[`${channelId}`],
          };
        }

        let newSortedList = [...sortedChannelList];
        const removedItems = newSortedList.splice(channelIndex, 1);
        return {
          channelId: channelId.toString(),
          pinnedChannelList: newPinnedChannelList,
          sortedChannelList: newSortedList,
          channel: data,
        };
      } else {
        const pinnedChannelIndex = [...pinnedChannelList].findIndex(
          (item) => item.toString() == channelId.toString()
        );

        let newPinnedChannelList = [...pinnedChannelList];
        const removedChannelId = newPinnedChannelList.splice(
          pinnedChannelIndex,
          1
        );
        const newSortedList = [`${channelId}`, ...sortedChannelList];
        return {
          channelId: channelId.toString(),
          pinnedChannelList: newPinnedChannelList,
          sortedChannelList: newSortedList,
          channel: data,
        };
      }
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);

export const fetchAsynDatapiece = createAsyncThunk(
  "chatslice/fetchAsynDatapiece",
  async (
    { referenceId, channelType }: { referenceId: number; channelType: number },
    { getState, rejectWithValue }
  ) => {
    try {
      const { cachedPivot, cachedChart } = getState()["chatState"] as ChatState;
      if (channelType == 0 && !cachedPivot.hasOwnProperty(`${referenceId}`)) {
        const data = await RestS.getDatapiece(referenceId, channelType);
        return { datapiece: data, channelType, referenceId };
      }

      if (channelType == 1 && !cachedChart.hasOwnProperty(`${referenceId}`)) {
        const data = await RestS.getDatapiece(referenceId, channelType);
        return { datapiece: data, channelType, referenceId };
      }
    } catch (error) {
      //
      return rejectWithValue(error ? error : "something went wrong");
    }
  }
);
